export {OpportunitiesKanbanModule} from './opportunitiesKanbanModule';
